import { Buttons, CancelButton, Drawer, Form } from '~/components';
import { useDocumentTitle } from '~/hooks';
import React from 'react';
import ReadTextbox from '~/components/read-only/ReadTextbox';

function PaymentTermDrawerView({ paymentTerm, onClose }) {
  const title = 'View Payment Terms';
  useDocumentTitle(title);

  function handleClose() {
    if (onClose) {
      onClose();
    }
  }

  return (
    <Drawer isOpen title={title} byline="Custom Data" onClose={handleClose}>
      <Form.Section
        title="Details"
        subtitle="Net terms are due the specified number of days after the invoice issue date. Net End-of-Month terms are due the specified number of days after the end of the month in which the invoice is issued.">
        <ReadTextbox label="Name" value={paymentTerm.name} />
      </Form.Section>

      <Drawer.Actions>
        <Buttons align="right">
          <CancelButton onClick={handleClose}>Close</CancelButton>
        </Buttons>
      </Drawer.Actions>
    </Drawer>
  );
}

export default PaymentTermDrawerView;
